import ClaimsComponent from './claims'
export default ClaimsComponent
